<script setup>
import { computed } from 'vue';
import { COIN_GOAL, coinGoalPercentage } from '@/utils/coins';

// De balk van het coin-saldo naar het doel, met de groenblauwe gradient. Dun in
// de sidebar (CoinProgressBar), dikker op "Mijn coins".
const props = defineProps({
  rate: { type: Number, required: true },
  large: { type: Boolean, default: false },
});

const percentage = computed(() => coinGoalPercentage(props.rate));
</script>

<template>
  <span
    class="coin-track"
    :class="{ 'coin-track--large': large }"
    role="progressbar"
    :aria-valuenow="rate"
    aria-valuemin="0"
    :aria-valuemax="COIN_GOAL"
  >
    <span class="coin-track__fill" :style="{ width: `${percentage}%` }"></span>
  </span>
</template>

<style scoped>
.coin-track {
  display: block;
  height: 0.4rem;
  overflow: hidden;
  border-radius: 999px;
  background: var(--grey-color-100);
}

.coin-track--large {
  height: 0.65rem;
}

.coin-track__fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--teal-color-400), var(--secondary-color));
  transition: width 500ms ease;
}
</style>
